import React from "react";
import styled from "styled-components";
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import { calculateDiscountedPrice } from "../../../utils/utils.ts";
import { URLPOZE } from "../../../utils/constants.ts";

const Wrapper = styled.div`
  max-width: 200px !important;
  height: calc(100% - 2rem);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid var(--primary-brown);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  max-width: 300px;

  &:hover {
    box-shadow: 0 0 8px 0 var(--primary-brown);
  }
`;

const Img = styled.img`
  width: auto;
  max-width: 300px;
  height: 200px;
  background-color: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(0, 0, 0, 0.3);
  object-fit: cover;

  @media (max-width: 768px) {
    height: 130px;
  }
`;
const ProductName = styled.div`
  color: var(--primary-green);
  font-size: 1.2rem;
`;
const ProductPrice = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;
const Price = styled.div`
  font-family: Verdana, sans-serif;
  font-size: 1rem;
`;
const StrikePrice = styled.div`
  font-family: Verdana, sans-serif;
  text-decoration: line-through;
  color: var(--tertiary-font-color);
  font-size: 0.8rem;
`;

const Icon = styled(IoArrowForwardCircleOutline)`
  align-self: flex-end;
  color: var(--primary-green);
  font-size: 1.5rem;
`;

interface Props {
  price: string;
  name: string;
  image: string;
  discount?: string;
  onClick: () => void;
  id: string;
}
const ProductTile: React.FC<Props> = ({
  price,
  name,
  discount,
  image,
  onClick,
  id,
}) => {
  return (
    <Wrapper id={id} onClick={onClick}>
      {image ? (
        <Img src={`${URLPOZE}${image}`} alt={`Product ${id}`} />
      ) : (
        <Img />
      )}
      <ProductName>{name}</ProductName>

      {discount && Number(discount) > 0 ? (
        <ProductPrice data-testid="product-price">
          <Price>{calculateDiscountedPrice(price, discount)} lei</Price>
          <StrikePrice>{price} lei</StrikePrice>
        </ProductPrice>
      ) : (
        <Price>{price} lei</Price>
      )}
      <Icon />
    </Wrapper>
  );
};

export default ProductTile;
